<app-button class="app-button" type="button" [isLoading]="isLoading"
            btnClass="fb-btn" [label]="label" icon="icon-fb"
            (click)="socialSignIn()">
</app-button>